import { put, call, takeEvery, all, select } from 'redux-saga/effects'

import {
  FETCH_VERTICALS,
  FETCH_VERSIONS,
  FETCH_TEMPLATE_TYPES,
  FETCH_VERTICAL_STATUS,
  FETCH_VERTICAL_PROGRESS,
  REINDEX_VERTICAL,
  STOP_SELENE_REINDEX,
  REINDEX_SELENE_BY_ID,
  SET_SELENE_VERSIONS,
  SET_TEMPLATE_TYPES,
} from '../actions/types'
import {
  fetchVerticalsSuccess,
  fetchVerticalsFailure,
  fetchVersionsSuccess,
  fetchVersionsFailure,
  fetchTemplateTypesSuccess,
  fetchTemplateTypesFailure,
  fetchVerticalStatusSuccess,
  fetchVerticalStatusFailure,
  fetchVerticalProgressSuccess,
  fetchVerticalProgressFailure,
  reindexVerticalSuccess,
  reindexVerticalFailure,
  stopReindexSuccess,
  stopReindexFailure,
  reindexByIdSuccess,
  reindexByIdFailure,
  setVersionsSuccess,
  setVersionsFailure,
  fetchVersions,
  fetchVerticalProgress,
  fetchVerticalStatus,
} from '../actions/seleneReindexActions'
import reindexService from '../services/seleneReindexService'
import { fetchProgress } from '../actions/autoVersioningActions'
import { allVerticalIdsSelector, verticalIndexNameSelector } from '../selectors/seleneReindexSelectors'

function* handleFetchVerticals(action) {
  try {
    const { accessToken } = action.payload
    const results = yield call(reindexService.fetchVerticals, accessToken)
    yield put(fetchVerticalsSuccess(results))
  } catch (err) {
    console.error(err, 'Error fetching verticals')
    yield put(fetchVerticalsFailure(err))
  }
}

function* handleFetchVersions(action) {
  try {
    const { accessToken } = action.payload
    const results = yield call(reindexService.fetchVersions, accessToken)
    yield put(fetchVersionsSuccess(results))
  } catch (err) {
    console.error(err, 'Error fetching versions')
    yield put(fetchVersionsFailure(err))
  }
}

function* handleFetchTemplateTypes(action) {
  try {
    const { accessToken } = action.payload
    const results = yield call(reindexService.fetchTemplateTypes, accessToken)
    yield put(fetchTemplateTypesSuccess(results))
  } catch (err) {
    console.error(err, 'Error fetching content types')
    yield put(fetchTemplateTypesFailure(err))
  }
}

function* handleFetchVerticalStatus(action) {
  const { verticalName, indexName, templateTypes, accessToken } = action.payload

  try {
    const results = yield call(reindexService.fetchVerticalStatus, accessToken, verticalName, indexName, templateTypes)
    yield put(fetchVerticalStatusSuccess(verticalName, indexName, results))
  } catch (err) {
    console.error(err, `Error fetching vertical status for '${verticalName}'`)
    yield put(fetchVerticalStatusFailure(verticalName, indexName, err))
  }
}

function* handleFetchVerticalProgress(action) {
  const { verticalName, accessToken } = action.payload

  try {
    const results = yield call(reindexService.fetchVerticalProgress, accessToken, verticalName)
    yield put(fetchVerticalProgressSuccess(verticalName, results))
  } catch (err) {
    console.error(err, `Error fetching vertical progress for '${verticalName}'`)
    yield put(fetchVerticalProgressFailure(verticalName, err))
  }
}

function* handleReindexVertical(action) {
  const { verticalName, templateTypes, accessToken } = action.payload

  try {
    yield call(reindexService.startReindex, accessToken, verticalName, templateTypes)
    yield put(reindexVerticalSuccess(verticalName))
    yield put(fetchVerticalProgress(verticalName, accessToken))
  } catch (err) {
    console.error(err, `Error starting reindex '${verticalName}'`)
    yield put(reindexVerticalFailure(verticalName, err))
  }
}

function* handleStopReindex(action) {
  const { verticalName, accessToken } = action.payload

  try {
    yield call(reindexService.stopReindex, accessToken, verticalName)
    yield put(stopReindexSuccess(verticalName))
    yield put(fetchVerticalProgress(verticalName, accessToken))
  } catch (err) {
    console.error(err, `Error stopping reindex for '${verticalName}'`)
    yield put(stopReindexFailure(verticalName, err))
  }
}

function* handleReindexById(action) {
  const { documentIds, accessToken } = action.payload

  try {
    yield call(reindexService.reindexById, accessToken, documentIds)
    yield put(reindexByIdSuccess())
  } catch (err) {
    console.error(err, `Error reindexing ids [${documentIds.join(', ')}]`)
    yield put(reindexByIdFailure(err))
  }
}

function* handleSetVersions(action) {
  const { versions, accessToken } = action.payload

  try {
    yield call(reindexService.setVersions, accessToken, versions)
    yield put(setVersionsSuccess())
    yield put(fetchVersions(accessToken))
    yield put(fetchProgress(accessToken))
  } catch (err) {
    console.error(err, `Error setting versions [${versions.join(', ')}]`)
    yield put(setVersionsFailure(err))
  }
}

function* handleSetTemplateTypes(action) {
  const { templateTypes, accessToken } = action.payload
  const verticals = yield select(allVerticalIdsSelector)
  yield all(
    verticals.map(function* (vertical) {
      const index = yield select(verticalIndexNameSelector, { id: vertical })
      yield put(fetchVerticalStatus(vertical, index, templateTypes, accessToken))
    })
  )
}

function* watchStatusSagas() {
  yield all([
    takeEvery(FETCH_VERTICALS, handleFetchVerticals),
    takeEvery(FETCH_VERSIONS, handleFetchVersions),
    takeEvery(FETCH_TEMPLATE_TYPES, handleFetchTemplateTypes),
    takeEvery(FETCH_VERTICAL_STATUS, handleFetchVerticalStatus),
    takeEvery(FETCH_VERTICAL_PROGRESS, handleFetchVerticalProgress),
    takeEvery(REINDEX_VERTICAL, handleReindexVertical),
    takeEvery(STOP_SELENE_REINDEX, handleStopReindex),
    takeEvery(REINDEX_SELENE_BY_ID, handleReindexById),
    takeEvery(SET_SELENE_VERSIONS, handleSetVersions),
    takeEvery(SET_TEMPLATE_TYPES, handleSetTemplateTypes),
  ])
}

export default watchStatusSagas
